import React from 'react'
import { Calendar } from '../OutplacementBenefits/Calendar'
import { Stack } from '~/components/_layouts'
import { useMediaQueryScreen } from '~/hooks/useMediaQuery'
import { useBenefits } from '../BenefitsProvider'
import { Card, Typography } from '~/components/_atoms/index'
import { useTranslation } from '~/hooks/useTranslation'

const UpcomingMeetings = () => {
  const { serviceRequestList } = useBenefits()

  const { t } = useTranslation('upcoming_meetings')

  const getCalendarEvents = () => {
    const events = []
    const requestTypes = Object.keys(serviceRequestList).filter(
      (key) =>
        serviceRequestList[key].calendly_event &&
        serviceRequestList[key].calendly_event.start_time,
    )
    requestTypes.forEach((requestTypes) => {
      const event = serviceRequestList[requestTypes].calendly_event
      if (event && event.start_time) {
        events.push(event)
      }
    })
    return events
  }

  const calendarEvents = getCalendarEvents()
  const isLargeScreen = useMediaQueryScreen('lg')

  return (
    <Stack spacing={3}>
      <div className="mt-4">
        {isLargeScreen && (
          <Card color="secondary">
            <Typography variant="subtitle" color="secondary">
              {t('title')}
            </Typography>
            <Typography>{t('description')}</Typography>
            <div className="relative">
              <Calendar
                calendar_events={calendarEvents}
                homePageDisplay={true}
                coachServices={true}
                opRedesign={true}
                coachDashboardDisplay={false}
              />
            </div>
          </Card>
        )}
      </div>
    </Stack>
  )
}

export default UpcomingMeetings
